import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { isValidNickname } from 'utils/utils';
import server from 'server/serverController2';

import Presenter from 'components/presenters/signup/SignupNicknameScene';
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter';

export default function NicknameFormScene({
    currSceneNum,
    totalSceneNum,
    onComplete,
    onError
}) {
    const [nickname, setNickname] = useState('');
    const [nicknameError, setNicknameError] = useState(null);

    const [isValid, setIsValid] = useState(false);

    const checkValid = () => {
        if(!isValidNickname(nickname) || nickname.length === 0)
        {
            return false;
        }
        return true;
    }

    const handleNicknameChange = (e) => {
        const nicknameValue = e.target.value;

        if(isValidNickname(nicknameValue) || nicknameValue.length === 0)
        {
            setNicknameError(null);
        }
        else
        {
            setNicknameError('닉네임은 특수문자 제외 2~10글자로 설정해 주세요');
        }
        setNickname(nicknameValue);
    }

    const checkNicknameExist = () => {
        return server.getRequestData(`auth/signup/validate?nickname=${nickname}`, (res) => {
            try
            {
                if(res.success !== 1)
                {
                    if(res['error']['res_data']['err_code'] === 'DATA_ALREADY_EXISTS' && res['error']['res_data']['detail_code'] === "NICKNAME_ALREADY_EXIST")
                    {
                        setNicknameError('이미 존재하는 닉네임입니다');
                        setIsValid(false);
                        return false;
                    }
                }
                return true;
            }
            catch(err)
            {
                console.log(err);
            }
        })
    }

    const handleNextScene = async () => {
        const isNicknameExist = await checkNicknameExist();
        if(isNicknameExist && onComplete)
        {
            onComplete(nickname);
        }
    }

    useEffect(() => {
        setIsValid(checkValid())
    }, [nickname])
    
    return (
        <NicknameFormWrapper>
            <Presenter 
            nickname={nickname}
            setNickname={setNickname}
            nicknameError={nicknameError}
            handleChangeNickname={handleNicknameChange}
            />
            <ScenePaginationFooter 
                currSceneNum={currSceneNum}
                totalSceneNum={totalSceneNum}
                onComplete={handleNextScene}
                valid={isValid}
            />
        </NicknameFormWrapper>
    )
}

const NicknameFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`